import { createAction, props } from '@ngrx/store';
import { UserInfo } from '../../../model/user.model';

/**
 * Set user (on login)
 */
export const setUser = createAction('[User] Set User', props<{ user: UserInfo }>());

/**
 * Clear user (on logout)
 */
export const clearUser = createAction('[User] Clear User');

/**
 * Update user profile action
 */
export const updateProfile = createAction(
  '[User] Update Profile',
  props<{ profile: Partial<UserInfo> }>(),
);

export const updateProfileSuccess = createAction(
  '[User] Update Profile Success',
  props<{ user: UserInfo }>(),
);

export const updateProfileFailure = createAction(
  '[User] Update Profile Failure',
  props<{ error: string }>(),
);

/**
 * Update user avatar action
 */
export const updateAvatar = createAction('[User] Update Avatar', props<{ file: File }>());

export const updateAvatarSuccess = createAction(
  '[User] Update Avatar Success',
  props<{ pictureUrl: string }>(),
);

export const updateAvatarFailure = createAction(
  '[User] Update Avatar Failure',
  props<{ error: string }>(),
);

/**
 * Load user profile action
 */
export const loadProfile = createAction('[User] Load Profile');

export const loadProfileSuccess = createAction(
  '[User] Load Profile Success',
  props<{ user: UserInfo }>(),
);

export const loadProfileFailure = createAction(
  '[User] Load Profile Failure',
  props<{ error: string }>(),
);
